import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config/app-config-service';
import { ThemeService } from 'src/app/pages/site-layout/themes/theme.service';
import { Themes } from 'src/app/pages/site-layout/themes/themes.enum';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-logo',
    templateUrl: './ndt-logo.component.html',
    standalone: false
})
export class NdtLogoComponent implements OnDestroy {
   @Input() logoWidth = 252.8;

   @Input() logoHeight = 100;

   isAdmin$ = new BehaviorSubject<boolean>(false);

   private destroyed$ = new Subject<void>();

   constructor(themeService: ThemeService, appConfigService: AppConfigService) {
      this.isAdmin$.next(appConfigService.getConfig().adminToken != null);
      themeService.currentTheme$.pipe(takeUntil(this.destroyed$)).subscribe(([_, newTheme]) => {
         this.isAdmin$.next(newTheme === Themes.Default);
      });
   }
   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
